import axios from "axios";
import fallbackPlans from "./../assets/data/plan.json";

const DEFAULT_API_URL = "https://api.osfatun.com.ar";

let plans = fallbackPlans.plan;

export async function fetchCartillaPlans() {
  const baseUrl = (process.env.VUE_APP_ROOT_API || DEFAULT_API_URL).replace(
    /\/+$/,
    ""
  );

  try {
    const response = await axios.get(`${baseUrl}/api/v1/cartilla/plans`);
    const remotePlans = response.data && response.data.plan;

    if (Array.isArray(remotePlans)) {
      plans = remotePlans;
    }
  } catch (error) {
    // El JSON incluido en el build mantiene operativa la cartilla si la API falla.
    plans = fallbackPlans.plan;
  }

  return plans;
}

export function getCartillaPlanName(id) {
  const selectedPlan = plans.find((plan) => String(plan.id) === String(id));
  return selectedPlan ? selectedPlan.name : "";
}
